import axios from "axios";
import Jsona from "jsona";
import messageUtils from "@utils/messageUtils";
import i18n from "@i18n";

const dataFormatter = new Jsona();

export const state = {
  shouldFetchFirmwares: false,
};

export const actions = {
  async getFirmwares({ commit }, payload) {
    try {
      const response = await axios.get(`/v1/sites/${payload.siteId}/firmwares${payload.params}`);
      return {
        data: dataFormatter.deserialize(response.data),
        headers: response.headers,
      };
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

  async addFirmware({ commit }, payload) {
    try {
      const formData = new FormData();
      formData.append("file", payload.file);

      await axios.post(`/v1/sites/${payload.siteId}/firmwares`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      messageUtils.showSuccess(i18n.t("firmwares.requests.add"));
    } catch (error) {
      messageUtils.showErrors(error);
      return Promise.reject(error);
    }
  },

};

export const mutations = {
  setShouldFetchFirmwares(state, value) {
    state.shouldFetchFirmwares = value;
  },
};
